import { getStateScale } from "../../services/ai/domain/stateScales.js";
import "./MoodSlider.css";

function MoodSlider({
  intent = "relax",
  value = 5,
  onChange,
  variant = "before",
}) {
  const config = getStateScale(intent);
  const title = variant === "after" ? "Et maintenant ?" : config.question;

  return (
    <div className="mood-slider">
      <div className="mood-slider__bounds">
        <span className="mood-slider__bound mood-slider__bound--left">
          {config.leftLabel}
        </span>
        <span className="mood-slider__bound mood-slider__bound--right">
          {config.rightLabel}
        </span>
      </div>

      <input
        type="range"
        min={0}
        max={10}
        step={1}
        value={value}
        onChange={(event) => onChange?.(Number.parseInt(event.target.value, 10))}
        className="mood-slider__input"
        aria-label={title}
        aria-valuemin={0}
        aria-valuemax={10}
        aria-valuenow={value}
      />

      <div className="mood-slider__value" aria-hidden="true">
        <span className="mood-slider__value-num">{value}</span>
        <span className="mood-slider__value-max">/10</span>
      </div>
    </div>
  );
}

export default MoodSlider;
